import { render, staticRenderFns } from "./EditOrderModals.vue?vue&type=template&id=1f992a4c&scoped=true&"
import script from "./EditOrderModals.vue?vue&type=script&lang=js&"
export * from "./EditOrderModals.vue?vue&type=script&lang=js&"
import style0 from "./EditOrderModals.vue?vue&type=style&index=0&id=1f992a4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f992a4c",
  null
  
)

export default component.exports